export default {
    init() {
    },
};